/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates the selection mode to use for the grid.
 */
export var GridSelectionMode = /*@__PURE__*/ (function (GridSelectionMode) {
    /**
     * No selection should be peformed based on interaction.
     */
    GridSelectionMode[GridSelectionMode["None"] = 0] = "None";
    /**
     * A single row is permitted to be selected at a time from interaction.
     */
    GridSelectionMode[GridSelectionMode["SingleRow"] = 1] = "SingleRow";
    /**
     * Multiple rows are permitted to be selected at a time from interaction.
     */
    GridSelectionMode[GridSelectionMode["MultipleRow"] = 2] = "MultipleRow";
    /**
     * A single cell is permitted to be selected at a time from interaction.
     */
    GridSelectionMode[GridSelectionMode["SingleCell"] = 3] = "SingleCell";
    /**
     * Multiple cells are permitted to be selected at a time from interaction.
     */
    GridSelectionMode[GridSelectionMode["MultipleCell"] = 4] = "MultipleCell";
    /**
     * Multiple cells are allowed to be selected however they are stored as ranges not individual cells.
     */
    GridSelectionMode[GridSelectionMode["RangeCell"] = 5] = "RangeCell";
    return GridSelectionMode;
})({});
/**
 * @hidden
 */
export var GridSelectionMode_$type = /*@__PURE__*/ markEnum('GridSelectionMode', 'None,0|SingleRow,1|MultipleRow,2|SingleCell,3|MultipleCell,4|RangeCell,5');
//# sourceMappingURL=GridSelectionMode.js.map
